import React from 'react';
import { observer } from 'mobx-react';
import BillCancellationDialog from './BillCancellationDialog';
import BillCancellationDialogService from '../services/BillCancellationDialogService';

const BillCancellationDialogContainer = () => (
  <BillCancellationDialog
    isOpen={BillCancellationDialogService.isOpen}
    submitting={BillCancellationDialogService.submit.fetching}
    onChange={BillCancellationDialogService.form.setValue}
    onCancel={BillCancellationDialogService.handleCancel}
    disabled={BillCancellationDialogService.form.getValue('status') === 'CANCELED'}
    onCancelBill={BillCancellationDialogService.handleCancelBill}
    values={BillCancellationDialogService.form.getValues()}
    errors={BillCancellationDialogService.form.errors}
  />
);

export default observer(BillCancellationDialogContainer);
